const textProps = {
  image: require("assets/img/faces/team-1.jpg").default,
  text: "Ray Tompson",
};
export default textProps;
